import { render } from "./SearchStaff.vue?vue&type=template&id=e1a79ed0"
import script from "./SearchStaff.vue?vue&type=script&lang=js"
export * from "./SearchStaff.vue?vue&type=script&lang=js"

import "@/assets/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./SearchStaff.vue?vue&type=style&index=1&id=e1a79ed0&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__